import { Check, CircleSlash, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type Props = {
  isLoading: boolean
  hasLinkedReport: boolean
  onClick: () => void
}

const EventRaidReportsBadge = ({
  isLoading,
  hasLinkedReport,
  onClick,
}: Props) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type='button'
          variant='ghost'
          size='icon'
          className='h-auto w-auto p-0 hover:bg-transparent bg-transparent'
          onClick={onClick}
        >
          <Badge variant='outline' className='gap-1.5'>
            <img
              src='https://data.wowaudit.com/img/wcl-logo.png'
              className='w-5 h-5'
            />
            {isLoading ? (
              <Loader2 className='h-3.5 w-3.5 animate-spin text-muted-foreground' />
            ) : hasLinkedReport ? (
              <Check className='h-4 w-4 text-success-foreground' />
            ) : (
              <CircleSlash className='h-4 w-4 text-muted-foreground' />
            )}
          </Badge>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {hasLinkedReport ? 'A report has been linked' : 'No report linked yet'}
      </TooltipContent>
    </Tooltip>
  )
}

export default EventRaidReportsBadge
